import { Grid, Typography } from "@mui/material";
import { IconButtonCancel } from "components/iconButtons";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";

interface IProps extends React.PropsWithChildren {
    text: string;
    variant?: "caption" | "captionHeader" | "bodyNotice";
    additionalInfo?: React.ReactNode;
    resetFilterText?: string;
    onResetFilter?: () => void;
}

export const MprcFilterCountText: React.FC<IProps> = (props) => {
    const { variant, resetFilterText, additionalInfo, text } = props;
    const { theme } = useMprcTheme();

    return (
        <Typography variant={variant ?? "caption"} component="span">
            <Grid container justifyContent="flex-start" alignItems="center">
                <Grid>
                    {text}
                    {
                        additionalInfo &&
                        <>&nbsp;{props.additionalInfo}</>
                    }
                </Grid>
                {
                    props.onResetFilter &&
                    <Grid>
                        <IconButtonCancel
                            title={resetFilterText ?? theme.MprcFilterCount.resetFilterText}
                            size="small"
                            onClick={props.onResetFilter}
                        />
                    </Grid>
                }
            </Grid>
            {props.children}
        </Typography>
    );
};
